import { Redacted } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export class MarkdownCopyFailure extends privateDependencyFailure<MarkdownCopyFailure>()("MarkdownCopyFailure", "Markdown clipboard") {}
export const markdownCopyFailure = (cause: unknown) => new MarkdownCopyFailure({ cause: Redacted.make(cause) });
export const markdownCopyResetMs = 1500;
export interface MarkdownCopySelection {
  readonly root: HTMLElement;
  readonly button: Element;
  readonly code: Element;
  readonly text: string;
}
